import { createSelector } from '@ngrx/store';

import { State } from '../reducers';
import { OrganizationsState } from '../reducers/organizations.reducer';

export const selectOrganizations = (state: State) => state.organizations;

export const selectDefaultOrganization = createSelector(
  selectOrganizations,
  (state: OrganizationsState) => state.defaultGid
);

export const selectDefaultOrganizations = createSelector(selectOrganizations, (state: OrganizationsState) => [
  state.defaultGid
]);
